import React from 'react';

interface ConnectionRoadmapProps {
  currentStep: string;
  completedSteps: string[];
  connectionId: string;
  onForceExit: (step: string, reason: string) => void;
}

export const ConnectionRoadmap: React.FC<ConnectionRoadmapProps> = ({
  currentStep,
  completedSteps
}) => {
  const steps = [
    { id: 'chat', name: 'Chat', icon: '💬' },
    { id: 'call', name: 'Bellen', icon: '📞' },
    { id: 'video', name: 'Video', icon: '📹' },
    { id: 'physical', name: 'Afspraak', icon: '🤝' }
  ];

  return (
    <div className="p-4">
      <h3 className="font-bold mb-4">Voortgang</h3>
      {steps.map((step) => (
        <div key={step.id} className="flex items-center gap-2 mb-2">
          <div className={`w-8 h-8 rounded-full flex items-center justify-center ${
            completedSteps.includes(step.id) ? 'bg-green-500 text-white' :
            step.id === currentStep ? 'bg-blue-500 text-white' : 'bg-gray-200'
          }`}>
            {completedSteps.includes(step.id) ? '✓' : step.icon}
          </div>
          <span>{step.name}</span>
        </div>
      ))}
    </div>
  );
};


